import { Reveal, Floral, GoldDivider } from "../components/Decor";
import { PADRINHOS } from "../constants/site";

export default function Padrinhos() {
  return (
    <div className="relative min-h-screen overflow-hidden pt-28" data-testid="page-padrinhos">
      <Floral variant="top" mirrored className="absolute -right-24 -top-6 w-80 opacity-85" />
      <header className="relative mx-auto max-w-3xl px-5 text-center">
        <p className="eyebrow">Uma homenagem</p>
        <h1 className="mt-4 font-script text-6xl text-ink sm:text-7xl">{PADRINHOS.title}</h1>
        <GoldDivider className="mt-8" />
      </header>

      <section className="relative mx-auto max-w-3xl px-5 pb-24 pt-6">
        <Floral variant="side" className="absolute -left-10 top-24 hidden w-24 opacity-60 lg:block" />
        <Reveal>
          <article className="paper-card gold-frame px-6 py-12 text-center sm:px-14" data-testid="padrinhos-cart">
            {PADRINHOS.paragraphs.map((p, i) => (
              <p
                key={i}
                className={
                  i === 0
                    ? "font-script text-3xl text-sage-dark"
                    : "mx-auto mt-6 max-w-2xl font-serif text-lg leading-relaxed text-ink/85 sm:text-xl"
                }
              >
                {p}
              </p>
            ))}
            <p className="mt-10 font-sans text-xs uppercase tracking-[0.3em] text-muted">{PADRINHOS.signature}</p>
            <p className="mt-3 font-script text-4xl text-ink">{PADRINHOS.names}</p>
          </article>
        </Reveal>
        <Floral variant="bottom" className="pointer-events-none absolute -bottom-14 -right-16 w-72 opacity-90" />
      </section>
    </div>
  );
}
